export { default } from "./shortcut-button";
